import React, { useState } from "react";
import profilePic from "../../assets/default.png";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Image,
  Row,
  ToggleButton
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SummaryBarWidget from "./widgets/SummaryBarWidget";
import HotKeywords from "./widgets/HotKeywords";
import HitsGraphWidget from "./widgets/HitsGraphWidget";

function DashboardPage({ authUserProfile }) {
  const navigate = useNavigate();
  const [graph, setGraph] = useState("Weekly")
  
  return (
    <div>
      <Row className="mt-2 gy-2">
        <Col md={1} xs={3}>
          <Image
            // src={authUserProfile?.user_profile?.avatar}
            src={profilePic}
            width={150}
            height={150}
            roundedCircle
            fluid
          />
        </Col>
        <Col md={8} xs={9}>
          <h4>
            Welcome, {authUserProfile?.first_name} {authUserProfile?.last_name}
          </h4>
          <span>Here's what's happening with your account today.</span>
        </Col>
        {!authUserProfile?.is_staff && (
          <Col md={3} xs={12}>
            <div className="d-grid gap-2">
              <Button
                variant="outline-danger"
                className="float-end"
                // onClick={() => !authUserProfile?.is_staff && navigate("/wallet")}
                onClick={() => navigate("/pocket/detail")}
              >
                Mini Statement
              </Button>
            </div>
          </Col>
        )}
      </Row>
      <Row className="mt-3 gy-3">
        <Col md={12}>
          <SummaryBarWidget />
        </Col>
      </Row>
      <Row className="mt-2 gy-3">
        <Col lg={8} md={12}>
        <Card>
          <Card.Header>
            <Col md={8}>
              Hits Graph
            </Col>
            <Col md={4}>
               
            </Col>
            </Card.Header>
              <Card.Body> 
                <Col md={12}>
                
                <ButtonGroup>
                <ToggleButton
                    id={`radio-1`}
                    type="radio"
                    variant={'outline-success'}
                    name="radio"
                    value='Monthly'
                    checked={graph === 'Monthly'}
                    onChange={(e) => setGraph(e.target.value)}
                  >
                    Monthly
                  </ToggleButton>
                  <ToggleButton
                    id={`radio-Weekly`}
                    type="radio"
                    variant={'outline-success'}
                    name="radio"
                    value='Weekly'
                    checked={graph === 'Weekly'}
                    onChange={(e) => setGraph(e.target.value)}
                  >
                    Weekly
                  </ToggleButton>
                </ButtonGroup>
                </Col>
                
                <HitsGraphWidget period={graph} />
                
          </Card.Body>
          </Card>
        </Col>
        <Col lg={4} md={12} xs={12}>
          <Card>
            <p className="p-2 border-bottom">Hot Keywords</p>
            <Card.Body>
               <HotKeywords />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DashboardPage;
